module.exports = __webpack_public_path__ + "img/HA1501-76.15a37f71.jpg";